import "../../athlete.css";

const Step1 = ({ userDetail, edit, setFormData, control }) => {
  const data = [
    {
      name:
        userDetail?.personal_information?.full_name ||
        userDetail?.personal_info?.full_name ||
        "--",
      label: "Nombre",
    },
    {
      name:
        userDetail?.personal_information?.document_id ||
        userDetail?.personal_info?.document_id ||
        "Documento no registrado",
      label: "documento",
    },
    {
      name:
        userDetail?.personal_information?.age ||
        userDetail?.personal_info?.age ||
        "Edad no registrada",
      label: "fecha de nacimiento",
    },
    {
      name:
        userDetail?.personal_information?.address ||
        userDetail?.personal_info?.address ||
        "Direccion no registrada",
      label: "direccion",
    },
    {
      name:
        userDetail?.personal_information?.mobile_number ||
        userDetail?.personal_info?.mobile_number ||
        "Telefono no registrado",
      label: "telefono",
    },
    {
      name:
        userDetail?.personal_information?.eps ||
        userDetail?.personal_info?.eps ||
        "EPS no registrada",
      label: "eps",
    },
  ];
  return (
    <div className="d-flex px-3 flex-column">
      <div className="d-flex justify-content-start">
        <span className="label-step">
          <strong>1. Información personal</strong>
        </span>
      </div>
      <div className="d-flex gap-3">
        {data.map((item, index) => {
          return (
            <input
              key={index}
              className={`step1-input_info_athlete input_info_athlete_input p-1 ${
                item.label == "eps" && edit ? "step1-all-border" : "step1-input"
              } `}
              placeholder={item.name}
              readOnly={item.label == "eps" ? !edit : true}
              onChange={(e) => {
                if (item.label == "eps" && edit) {
                  if (control) {
                    setFormData((prev) => ({
                      ...prev,
                      personal_info: {
                        ...prev.personal_info,
                        eps: e.target.value,
                      },
                    }));
                  } else {
                    setFormData((prev) => ({
                      ...prev,
                      personal_information: {
                        ...prev.personal_information,
                        eps: e.target.value,
                      },
                    }));
                  }
                }
              }}
            />
          );
        })}
      </div>
    </div>
  );
};
export default Step1;
